import _defineProperty from "/usr/share/nginx/html/gatsby_lat_page_desk/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/share/nginx/html/gatsby_lat_page_desk/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/usr/share/nginx/html/gatsby_lat_page_desk/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["animation", "bg", "bsPrefix", "size"],
    _excluded2 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import { useCol } from './Col';
export default function usePlaceholder(_ref) {
  var animation = _ref.animation,
      bg = _ref.bg,
      bsPrefix = _ref.bsPrefix,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);

  bsPrefix = useBootstrapPrefix(bsPrefix, 'placeholder');

  var _useCol = useCol(props),
      _useCol2 = _slicedToArray(_useCol, 1),
      _useCol2$ = _useCol2[0],
      className = _useCol2$.className,
      colProps = _objectWithoutProperties(_useCol2$, _excluded2);

  return _objectSpread(_objectSpread({}, colProps), {}, {
    className: classNames(className, animation ? "".concat(bsPrefix, "-").concat(animation) : bsPrefix, size && "".concat(bsPrefix, "-").concat(size), bg && "bg-".concat(bg))
  });
}